import React from 'react'
import { createUseStyles } from 'react-jss'
import { colors } from '../../../theme/palette'

interface Props {
    text: string
    error?: string | undefined
}

const useStyles = createUseStyles(() => ({
    message: {
        position: 'relative',

        fontSize: '15px',
        textAlign: 'right',
        paddingTop: '5px',
    },
    text: {
        position: 'relative',
        color: colors.labelColor,
    },
    error: {
        position: 'relative',
        color: colors.error,
    },
}))

const FormMessage: React.FC<Props> = ({ text, error }) => {
    const classes = useStyles()

    return (
        <div className={classes.message}>
            {/* {!error ? <span className={classes.text}>{text}</span> : null} */}
            {error ? <span className={classes.error}>{error}</span> : null}
        </div>
    )
}

export { FormMessage }
